import React from "react";
import Headers from "../Header/Header";
import "./contact.css";
import img from "../../assets/Untitled-1-0۱ 1.png";
const Contact = () => {
  return (
    <div className="contact-box">
      <Headers />
      <div className="contact-content">
        <div className="contact-form row m-0">
        <div className="col-md-6">
        <input className="form-control contact-input-style" placeholder="نام ونام خانوادگی"/>
        <input className="form-control contact-input-style" placeholder="آدرس پست الکترونیک"/>
        <input className="form-control contact-input-style" style={{height:"100px"}} placeholder="متن پیام"/>
        </div>
        <div className="col-md-6 d-flex align-items-center justify-content-center">
        <div className="contact-btn-box">
        <button className="btn">ارسال پیام</button>
        </div>
        </div>
        </div>
        <div className="contact-img-box">
          <img alt="" src={img} />
        </div>
      </div>
    </div>
  );
};

export default Contact;
